module.exports = __webpack_public_path__ + "static/media/inSelectArrowDown.c3bf8ddd.svg";